import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { ADDRESS_FEATURE_KEY } from './address-collection.state';
import { AddressEffects } from './effects/address.effects';
import { addressReducer } from './reducers/address.reducer';
import { selectAddresses } from './selectors/address.selector';

/**
 * Registers the address store slice. Import once where the timesheet feature is
 * bootstrapped (apps/pace `TimesheetModule`, next to `TimesheetStoreModule`) —
 * the module is eagerly loaded there, so the slice and its load effect exist
 * before `TimesheetAndExpensesNgrxService.init()` dispatches `initAddresses`.
 *
 * The slice registers its projection selector with the generic persistence layer, which
 * persists the collection to the concurrency store under the default `addressSlice` key. This
 * is a different backend from the legacy `StorageAddressService` (encrypted file storage under
 * `addressCollection`): with the NgRx path active the two no longer share storage, so the
 * collection does not carry across an `enableNgRx` flag flip. A cross-backend data
 * migration is deferred until the overall NgRx migration is complete.
 */
@NgModule({
    imports: [StoreModule.forFeature(ADDRESS_FEATURE_KEY, addressReducer), EffectsModule.forFeature([AddressEffects])],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: ADDRESS_FEATURE_KEY,
                persistSelector: selectAddresses,
            },
        },
    ],
})
export class AddressStoreModule {}
